export enum InputTypes {
  Password = 'password',
  Text = 'text',
  TextArea = 'textarea',
}
